export enum Integration {
  Adyen = 'adyen',
  Hubspot = 'hubspot',
  Stripe = 'stripe',
  Webhook = 'webhooks',
  SMTP = 'smtp',
}
